<template>
	<section
		id="page-heading"
		v-if="currentPage && currentPage.acf"
		class="head_watch page-heading margin-top-lg margin-bottom-lg"
		:class="'type-' + currentPostType"
	>
		<transition :style="{ '--totalStagger': 4 }" name="slide-in" appear>
			<Breadcrumbs :style="'--indexStagger: 1'" class="container__large margin-auto" :self="false" />
		</transition>
		<div class="page-info container__large margin-auto">
			<transition-group duration="600" :style="{ '--totalStagger': 4 }" tag="div" name="slide-in" appear>
				<h1 key="title" :style="'--indexStagger: 2'" class="page-title">{{ currentPage.title }}</h1>
				<div
					key="excerpt"
					:style="'--indexStagger: 3'"
					v-if="currentPage.acf.page_excerpt"
					class="page-excerpt margin-top-lg"
					v-html="currentPage.acf.page_excerpt"
				></div>
			</transition-group>
		</div>
	</section>
</template>

<script>
import Breadcrumbs from '@/components/parts/Breadcrumbs'

import { mapGetters } from 'vuex'

export default {
	name: 'single-heading',
	components: {
		Breadcrumbs,
	},
	computed: {
		...mapGetters(['currentPage', 'currentPostType', 'isArchive']),
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';
.page-heading {
	@include mquery($phone) {
		margin-right: -35px;
	}
	.page-info {
		padding-right: 116px;
		@include mquery($tablet) {
			padding-right: 87px;
		}
		@include mquery($phone) {
			padding-right: 15px;
		}
	}
}
</style>
